var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#copy_svg__pattern0_5426_1901)",
    d: "M0 0h17v17H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "copy_svg__pattern0_5426_1901",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#copy_svg__image0_5426_1901",
    transform: "scale(.0303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "copy_svg__image0_5426_1901",
    width: 33,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIaADAAQAAAABAAAAIQAAAAAWQIAAAAABnUlEQVRYCe1V0VHDMAwtHANkhGyAN4ANCJuwAR6BEdigYQOYoN6AbNAwAbzHRfDahjvLSdN+oLt3lt33JFl23NXq1yLcDfBZiC10ayAARZagKk0+pmu8VcSZC2BR7EoFZJt2IWarDok1ljSWqxvazsPQvpUn0C1ezJVe5hIzeX0mb4c2dxGdROfRZNlVFiuf1ILKblQA/Sy7AItnaMb54jb3cRRtoPQ4ArLdAGx7iSWI3oDexPZJ6bHYb/sjk/JpVk2pzwetsQQaxNb+Glv8oPw5/OC5mAEFbKS6F/hJ5h6XHbgeBIyzs7NhfXR4EO7zKCN/kRuyLm49X0clOTrxS9wkospThOjmdc+miA/ZVy3+Yi4fq1fgbsi4HuY9xg7gzaV/dAvIYDd1f2wkexQe/an2k4t3IgH3gB7L1AQuvf13tFDVwC3AztA6gOtHNyuCiXqASRdJzIRmZ/OJWkEnG/87Ya0/VScqK8A7NhDYA/MOv/YGGPgs4BGwWMkTh+JexBZk6hg9RZDbAFOTqt7VBS02YNIC/YSCmDwC3/YFk53plg94FqkAAAAASUVORK5CYII="
  }))));
}

export default SvgCopy;